// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EditFilledSvg from "@fishx/icons-svg/es/asn/EditFilled";
import FishxIcon from '../components/FishxIcon';

var EditFilled = function EditFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: EditFilledSvg
  }));
};

EditFilled.displayName = 'EditFilled';
export default React.forwardRef(EditFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/EditFilled.js
// module id = 2587
// module chunks = 0